<template>
    <div class="w-100" style="min-width: 200px">
        <v-select v-if="customers" class="vue-select2" id="cust_id" name="select2"
                  :options="customers" label="na"
                  :model.sync="selected_customer"
                  v-model="selected_customer"
                  :searchable="true" language="lt-LT">
        </v-select>
        <input type="text" id="rf1" v-if="!customers" v-model="query" class="form-control"
               placeholder="Rasti klientą Rivile" title="Reikalavimas: min 3 raidės" value="Rasti klientą Rivileje" @keyup="loadCustomers()">
    </div>
</template>

<script>
    import vSelect from 'vue-select';

    export default {
        name: "RivileSearch",
        components: {
            vSelect,
        },
        data() {
            return {
                customers: '',
                selected_customer: '',
                query: ''
            }
        },
        methods: {
            loadCustomers() {
                if ( this.query.length > 2) {
                    axios.get('/rivile_customer/'+this.query).then(res => {
                        var mapObj = {
                            ą: "a",
                            č: "c",
                            ę: 'e',
                            ė: 'e',
                            į: "i",
                            ų: "u",
                            ū: "u",
                            š: "s",
                            ž: "z",
                            Ą: "A",
                            Č: "C",
                            Ę: "E",
                            Ė: "E",
                            Į: "I",
                            Š: "S",
                            Ų: "U",
                            Ū: "U",
                            Ž: "Z"

                        };
                        for (let index = 0; index < res.data.length; index++) {
                            var str = res.data[index].N08_PAV + ' ' + res.data[index].N08_ADR + ' ' + res.data[index].N08_TEL;
                            var fix = str.replace(/ą|č|ę|ė|į|š|ų|ū|ž/gi, function (matched) {
                                return mapObj[matched];
                            });
                            res.data[index].na = fix;

                        }
                        console.log(res.data);
                        this.customers = res.data;
                    });
                }
            }
        },
        mounted() {
            // this.$refs.searchbar.$el.focus();
            // axios.get('/get_customers').then(res => {
            //     this.customers = res.data
            // });
        },
        watch: {

            selected_customer: function (val) {
                window.location.assign('/riv_customer/null/' + val.N08_KODAS_KS);
            }
        }
    }
</script>

<style scoped>

</style>